import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map, } from 'rxjs/operators';
import { LookUp } from '../models/lookUp.model';
import { ToastrService } from 'ngx-toastr';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';

@Injectable({
    providedIn: 'root',
})
export class LookUpService extends BaseService<LookUp> {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    API_URL = `${environment.apiUrl}/lookup`;
    API_URLGetAll = `${environment.apiUrl}/lookUp`;
    API_URLFind = `${environment.apiUrl}/lookUp/Find`;
    API_URLAdd = `${environment.apiUrl}/lookUp`;
    API_URLUpdate = `${environment.apiUrl}/lookUp`;
    API_URLDelete = `${environment.apiUrl}/lookUp`;
    API_URLGetById = `${environment.apiUrl}/lookUp`;
    constructor(@Inject(HttpClient) http,  public toastr: ToastrService, public translationServices: TranslationService) {
        super(http,  toastr, translationServices);

    }
    getAllStatickslist$(): Observable<any> {
        let url = `${this.API_URL}/Statickslist`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }
    searchAll$(keyword: string): Observable<any> {
        let url = `${this.API_URL}/${this.langId}/${keyword}`;
        return this.http.get<any>(url).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }


}
